import env                                from '../env';
import { fetchJSON }                      from '@statflo/fetch';
import {
    Messages,
    MessagesRange,
    CommcontrollerPayload
}                                         from '../types';
import * as qs                            from 'query-string';
import { getSession }                     from './SessionService';

type MessageFeedPayload = CommcontrollerPayload<{ messages: Messages, total_count: number }>;

export default async function messageFeedService(conversationId: number, range: MessagesRange): Promise<MessageFeedPayload> {
    const session = await getSession();
    const requestConfig: RequestInit = {
        method: 'GET',
        headers: new Headers({
            Authorization: `Bearer ${session.token}`
        }),
        mode: 'cors',
        cache: 'no-cache'
    };
    const params = qs.stringify({ conversation_id: conversationId, ...range });

    return fetchJSON<MessageFeedPayload>(`${env.MESSAGE_LIST_HOST}/v1/rest/messages/?${params}`, requestConfig);
}



// WEBPACK FOOTER //
// ./src/services/MessageFeedService.ts